<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates45">
<p class="centerImage"><img alt="images" id="plate45" src="images/plate45.jpg"/></p>
<p class="caption">RWF with B Flight’s stalwart ground crews.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates45.vue?44d89380